import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { NotificacionesEmbarazoTh } from './TypesNotificacionEmbarazoTh';
import { InactivarNotificacionEmbarazo, ObtenerInformacionNotificacionesEmbarazo } from './FunctionsNotificacionEmbarazoTh';
import Cargando from 'components/Varios/Cargando';
import TableNotificacionEmbarazoTh from './TablaNotificacionEmbarazoTh';
import { GetDocumentVistaPrevia } from 'helpers/files';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ScrollToTop } from 'functions/LayoutFunctionst';


type StateAprobacionSolicitudes = {
    filasTabla: NotificacionesEmbarazoTh[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

export default function NotificacionEmbarazoTh() {
    const TITULO_APROBACION_SOLICITUDES = "VALIDACIÓN DE NOTIFICACIÓN DE EMBARAZO";

    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalInformacionRechazar: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: ""
    }

    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [stateinformacionModalRechazar, setstateinformacionModalRechazar] = useState(defaultStateModalInformacionRechazar)


    async function ObtenerDatosSolicitudes() {
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true })
        const resultado = await ObtenerInformacionNotificacionesEmbarazo()
        if (resultado.status === 200) {

            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false })
            }

        } else {
            setstateAprobacion(prev => ({ ...prev, mensajeError: "Usted no está autorizado para realizar las validaciones de estas solicitudes", loadingFilas: false, errorFilas: true }));

        }
        
    }

    useEffect(() => {
        ObtenerDatosSolicitudes();
    }, [])

    function AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones): any {
        //Date fechaActual = new Date();
        const fechaActual = new Date().toISOString().split('.')[0];
        return(
                <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Identificacion</th>
                            <th> Nombre</th>
                            <th> Fecha Certificado</th>
                            <th> Fecha Estimada Parto</th>
                            <th> Fecha Interrupción</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                {informacionAcciones.numeroIdentificacion}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaCertificado)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaEstimadaParto)}
                                </div>

                            </td>
                            
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(fechaActual)}
                                </div>

                            </td>
                        </tr>

                    </tbody>
                </Table>
                </>
        )
    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    function onClickInactivarEmbarazo(informacionAcciones) {
        const modalContent = AuxiliarGenerarHTMLBodyModalPermisos(informacionAcciones);

        setstateinformacionModalRechazar({
            cargando: false,
            idSolicitud: informacionAcciones.idEmbarazo,
            modalContent,
            tituloModal: "Registrar Interrupción de Embarazo"
        })
    }

    const tablaNotificacionEmbarazos = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla , mensajeError} = stateAprobacion
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        }else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TableNotificacionEmbarazoTh 
                    dataFilas={stateAprobacion.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickRechazar = {(solicitud: any) => onClickInactivarEmbarazo(solicitud)}
                />
                
            )

        }
        else {
            return (
                <TableNotificacionEmbarazoTh
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => {;}}
                    onClickRechazar = {(solicitud: any) => {;}}
                />
            )
        }

    }, [stateAprobacion])

    async function OnCloseModalValidacion() {
        await ObtenerDatosSolicitudes()
        setstateinformacionModalRechazar(defaultStateModalInformacionRechazar)
        ScrollToTop();
    }

    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_APROBACION_SOLICITUDES} </div>
            {tablaNotificacionEmbarazos}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Certificado de embarazo'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalConfirmacion
                show={stateinformacionModalRechazar.idSolicitud > 0 || stateinformacionModalRechazar.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazar(defaultStateModalInformacionRechazar)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea registrar la interrupción de embarazo?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => InactivarNotificacionEmbarazo(stateinformacionModalRechazar.idSolicitud)}
                contentModal={stateinformacionModalRechazar.modalContent}
                tituloModal={stateinformacionModalRechazar.tituloModal}
                asyncAfterOnClose={() => OnCloseModalValidacion()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}


            />
        </div>
    )

}
